module.exports = __webpack_public_path__ + "static/raleway-latin-300-3738d553a5f0fdfe93576873606bf445.woff2";